import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Box, Button, Icon, Popover, TextField } from '@popmenu/common-ui';
import { CheckCircle, Send } from '@popmenu/web-icons';
import { classNames, makeStyles } from '../../../utils/withStyles';

const useStyles = makeStyles(theme => ({
  copyButton: {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    fontSize: '0.75rem',
    left: '-1px',
    minWidth: '70px',
    position: 'relative',
  },
  copyButtonCopied: {
    color: theme.palette.green.main,
    fontSize: '1.25rem',
    fontWeight: 'bold',
  },
  popoverContainer: {
    display: 'flex',
    padding: theme.spacing(2),
  },
  shareButton: {
    borderRadius: theme.spacing(3),
    color: theme.palette.text.primary,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    textTransform: 'none',
  },
  textField: {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    fontSize: '0.75rem',
  },
}));

export const DishShareButton = ({ shareUrl }: { shareUrl: string }) => {
  const classes = useStyles();
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [copied, setCopied] = useState<boolean>(false);

  const onShareButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(null);
    setCopied(false);
  };
  const muiPopoverId = 'share-popover';

  const onCopy = () => {
    setCopied(true);
  };

  return (
    <React.Fragment>
      <Button
        aria-haspopup="true"
        aria-label={intl.formatMessage({ defaultMessage: 'Open Share Popup' })}
        aria-owns={anchorEl ? muiPopoverId : undefined}
        className={classes.shareButton}
        onClick={onShareButtonClick}
        variant="outlined"
      >
        <Icon icon={Send} />
      </Button>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        id={muiPopoverId}
        onClose={onClose}
        open={Boolean(anchorEl)}
      >
        <Box className={classes.popoverContainer}>
          <TextField
            InputProps={{
              className: classes.textField,
            }}
            value={shareUrl}
          />
          <CopyToClipboard onCopy={onCopy} text={shareUrl}>
            <Button
              className={classNames(
                classes.copyButton,
                copied ? classes.copyButtonCopied : null,
              )}
              variant="outlined"
            >
              {copied ? (
                <Icon
                  aria-label={intl.formatMessage({ defaultMessage: 'Link Copied' })}
                  icon={CheckCircle}
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Copy"
                />
              )}
            </Button>
          </CopyToClipboard>
        </Box>
      </Popover>
    </React.Fragment>
  );
};
